import { api, protectedApi } from '@/client/utils'

export const updateMutateDesignService = async () => ({
  success: true,
  redirect_url: '/design-service?briefId=4359348953450340834985304'
})
/**
 *
 * @param payload  Design service form data.
 * @param cartId  Current user cart ID.
 * @param customerId  Current user log in ID.
 * @returns Cart updates.
 */
export const updateMutateDesignServiceBrief = async (locale, payload, cartId, customerId) => {
  const url = `/design-service/${locale}/${customerId}/${cartId}`
  const { data } = await protectedApi.post(url, JSON.stringify(payload))
  return data
}

/**
 *
 * @param locale Lang
 * @returns Initial Design service form fields.
 */
export const getDsData = async (locale: string) => {
  const url = `/design-service/${locale}`
  const { data } = await api.get<any>(url)
  return data
}
